import Logo from "./logo.png";
import Banner from "./banner.jpg";
import Subscribe from "./subscribe.jpg";
import Feature1 from "./feature1.svg";
import Feature2 from "./feature2.svg";
import Feature3 from "./feature3.svg";
import PhonePlaceholder from "./phoneplaceholder.png";
import AppImg1 from "./img1.png";
import AppImg2 from "./img2.png";
import AppImg3 from "./img3.png";
import AppImg4 from "./img4.png";
import AppImg5 from "./img5.png";
import AboutUs from "./aboutus.png";
import HowItWorksIcon1 from "./howitworkicon1.svg";
import HowItWorksIcon2 from "./howitworkicon2.svg";
import HowItWorksIcon3 from "./howitworkicon3.svg";
import Shape from "./shape.png";
import DownloadImg from "./download.png";
import GoogleImg from "./google.svg";
import AppleImg from "./apple.svg";

export const IMAGES = {
    AppleImg,
    GoogleImg,
    DownloadImg,
    Shape,
    HowItWorksIcon1,
    HowItWorksIcon2,
    HowItWorksIcon3,
    AboutUs,
    AppImg1,
    AppImg2,
    AppImg3,
    AppImg4,
    AppImg5,
    Logo,
    Banner,
    Subscribe,
    Feature1,
    Feature2,
    Feature3,
    PhonePlaceholder
}

const appTheme = { IMAGES };
export default appTheme;